import React, { useState } from "react";
import { UserTeam } from "@/services/staffService";
import { TeamMultiSelect } from "../TeamMultiSelect";
import { useUpdateStaff } from "../../hooks/useStaff";
import { useTranslation } from "react-i18next";
import { toast } from "sonner";

interface TeamsCellProps {
  userTeams: UserTeam[];
  staffId: string;
}

export const TeamsCell: React.FC<TeamsCellProps> = ({ userTeams, staffId }) => {
  const { t } = useTranslation();

  const [userTeamIds, setUserTeamsIds] = useState<string[]>(
    userTeams.map((ut) => ut.teamId),
  );

  const updateStaff = useUpdateStaff();

  const handleChangeUserTeams = async (teamsIds: string[]) => {
    try {
      setUserTeamsIds(teamsIds);

      await updateStaff.mutateAsync({ id: staffId, data: { teams: teamsIds } });

      toast.success(t("staff.successUpdateTeams"));
    } catch (err) {
      console.error("Failed to update staff:", err);
    }
  };

  return (
    <div className="flex gap-1 justify-center flex-wrap">
      <TeamMultiSelect
        placeholderSelected="Teams"
        selectedTeamIds={userTeamIds}
        onSelectionChange={handleChangeUserTeams}
      />
    </div>
  );
};
